import { load } from 'reducers/selectedOrgId';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const useLoadSelectedEffect = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(load());
  }, [dispatch]);
};

export default useLoadSelectedEffect;
